export default __webpack_public_path__ + "7ac4bd83bcf0bcf9bec8b566398d1fe0.png";